import React, { Component } from "react"
import { Mutation } from "react-apollo"
import PropTypes from "prop-types"
import NEWSLETTER_SUBSCRIBE from "../../../graphql/newsletterSubscribe.graphql"
import Modal from "../../Modal"
import { EMAIL_REGEX } from "../../../shared/constants"
import "./NewsletterModal.scss"

class NewsletterModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ...props,
      isModalOpen: false,
      email: "",
      errors: { email: false },
      inputBlur: false,
      successMessage: null,
    }
  }

  trackEvent = () => {
    if (this.props.trackEvent) {
      this.props.trackEvent("Newsletter modal sign up", {
        email: this.state.email,
        slug: this.props.slug || "",
      })
    }
  }

  isValidEmail = () => {
    let reg = EMAIL_REGEX
    let isValid = reg.test(this.state.email)
    if (isValid && this.state.email.length !== 0) {
      this.setState({ errors: { email: false } })
    } else {
      this.setState({
        errors: { email: "Invalid Email." },
      })
    }
  }

  handelInputChange = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        if (this.state.inputBlur) {
          this.isValidEmail()
        }
      }
    )
  }

  handelKeyPress = (e) => {
    if (e.key === "Enter") {
      this.handelSinup()
      this.onInputBlur()
      this.trackEvent()
    }
  }

  handelCloseModal = () => {
    this.setState({ isModalOpen: false })
  }

  componentDidMount() {
    let { delay } = this.props
    if (delay) {
      delay = delay * 1000
    }
    setTimeout(() => {
      this.setState({ isModalOpen: true })
    }, delay)
  }

  onInputBlur = () => {
    this.setState({
      inputBlur: true,
    })
  }

  handelSinup = () => {
    let { email, errors } = this.state
    let sinupErrors = Object.assign({}, this.state.errors)
    let blur = this.state.inputBlur
    let successMessage = null

    this.trackEvent()

    this.props.newsletterSubscribe({ variables: { email } }).then((res) => {
      let { subscribeNewsletter } = res.data

      if (subscribeNewsletter.payload === "invalid") {
        sinupErrors.email = "Invalid Email."
        blur = true
      }
      if (subscribeNewsletter.payload === "exists") {
        sinupErrors.email = subscribeNewsletter.message
      }
      if (subscribeNewsletter.payload === "success") {
        sinupErrors.email = false
        successMessage = "Thank you for subscribing to our newsletter."
      }
      this.setState({
        errors: sinupErrors,
        inputBlur: blur,
        successMessage: successMessage,
      })
    })
  }

  render() {
    const { title, description, isModalOpen, successMessage } = this.state
    return isModalOpen ? (
      <Modal
        isOpen={isModalOpen}
        closeIcon={true}
        close={this.handelCloseModal}
        classes={["newsletter-modal--component"]}
      >
        <section>
          {title && <h2>{title}</h2>}
          {description && <p>{description}</p>}
          {successMessage ? (
            <div className="form-success">
              {this.state.successMessage}
              <button
                className="btn btn-primary"
                onClick={this.handelCloseModal}
              >
                Close
              </button>
            </div>
          ) : (
            <div className="input-group mb-3 newsletter-form">
              <input
                type="text"
                className={`form-control input-outline ${
                  this.state.errors.email ? "error" : ""
                }`}
                placeholder="Enter your email address"
                name="email"
                aria-label="Recipient's email"
                aria-describedby="button-addon2"
                onChange={this.handelInputChange}
                onBlur={this.onInputBlur}
                onKeyPress={this.handelKeyPress}
              />
              <div className="input-group-append">
                <button
                  className="btn btn--subscription "
                  id="button-addon2"
                  onClick={this.handelSinup}
                >
                  Subscribe
                </button>
              </div>
              {this.state.errors.email && (
                <p className="message--error">{this.state.errors.email}</p>
              )}
            </div>
          )}
        </section>
      </Modal>
    ) : null
  }
}

NewsletterModal.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  delay: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

NewsletterModal.defaultProps = {
  title: "Newsletter",
  description: "",
  delay: 4,
}

const NewsletterModalWithDatat = (props) => (
  <Mutation mutation={NEWSLETTER_SUBSCRIBE}>
    {(mutate) => <NewsletterModal {...props} newsletterSubscribe={mutate} />}
  </Mutation>
)

export default NewsletterModalWithDatat
